<template>
	<div class="index-login p-b-70">
		<div class="main" :style="'background:'+ produInfo.colorList[0]">
			<img :src="baseUrl+produInfo.images[0]" />

			<div id="form"></div>
			<el-form :model="form" :rules="rules" ref="form">
				<el-form-item  prop="mobile">
					<div class="df">
						<el-input v-model.number="form.mobile" placeholder="请输入手机号" @input="handlePhone">
							<span slot="prefix">+86</span>
						</el-input>
						<div class="el-form-item__error" v-if="showError">{{showText}}</div>
					</div>
				</el-form-item>
				<el-form-item  prop="code">
					<el-input v-model="form.code" placeholder="请输入验证码" @input="handleSms">
						<el-button @click="getCode" :disabled="timer"  slot="suffix" :style="'background:' + produInfo.colorList[1] + ';border-color:' + produInfo.colorList[1]">{{ timer ? `${count}秒后重新获取` : '获取验证码' }}</el-button>
					</el-input>
				</el-form-item>
			</el-form>
			<div class="cbtn" @click="submitForm('form',0)" :style="'background:'+ produInfo.colorList[2]">
				<div class="text">立即点击报名</div>
			</div>

			<img :src="baseUrl+item" v-for="(item, index) in produInfo.images" :key="index" v-if="index > 0" />
		</div>

		<div class="footer">
			<div class="price">{{ produInfo.productPrice || 1 }}</div>
			<div class="text" @click="submitForm('form')">
				<div class="breathe">立即报名</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';

	var checkPhone = (rule, value, callback) => {
		const regPhone = /^1[3|4|5|6|7|8|9][0-9]{9}$/
		if (value === '') {
			return callback(new Error('手机号不能为空'))
		} else if (!regPhone.test(value)) {
			callback(new Error('请输入正确的手机号'))
		} else {
			callback()
		}
	};

	export default {
		data () {
			return {
				productId:1,
				produInfo:{},
				imagesList:[],
				baseUrl:`${this.$siteURL}/imgs/mini/`,
				pathId:'',//投放平台pathid
				timer:false,
				count: 60,
				showText:'',
				showError:false,
				form: {
					code:'',
					mobile: ''
				},
				rules: {
					code:[{ required: true, message: '请输入验证码', trigger: 'blur' }],
					mobile: [
						{ required: true, message: '请输入手机号', trigger: 'blur' },
						{ validator: checkPhone, trigger: 'blur' }
					]
				},
				phoneLcok:false,//手机输入埋点
				smsLock:false
			}
		},
		created(){
			this.form = {
				mobile: this.$store.state.phone,
				code:	this.$store.state.code
			}
			this.productId = this.$route.query.productId || 1   //产品ID
			this.feedBack()
			this.getList()
		},
		methods:{
			feedBack(){
				let path = encodeURIComponent(window.location.href)
				let parms = getQueryObject()
				axios({
					method:"GET",
					url:`${this.$baseURL}/getGeneralIndex`,
					params:{
						putIndex: path,	
						channels: parms.channels || '0',
						productId: parms.productId || '1',
						cctid: parms.cctid || '0',
						strid: parms.strid || '0',
						bepid: parms.bepid || '0',
						pathId: parms.bd_vid || ''
					}
				}).then(res => {
					this.pathId = res.data.data.pathId
					this.$store.commit("SET_PATHID", this.pathId)
				})
			},
      		getList(){
				axios({
					method:'GET',
					url: `${this.$baseURL}/queryProductInfo`,
					params:{
						productId: this.productId
					}
				}).then(res => {
					this.produInfo = res.data
					this.produInfo.colorList = res.data.theme && res.data.theme.indexOf(',') > 0 ? res.data.theme.split(',') : ['#fff','#1ACE9A','#1ACE9A']
				})
			},
			handlePhone(val){
				if(val.length > 6){
					if(this.phoneLcok){
						return false
					}
					this.phoneLcok  = true
					let that = this
					setTimeout(() => {
						that.phoneLcok  = false
						that.doPoint('ecEnterPhone')//埋点
					},2000)
				}else{
					this.phoneLcok  = false
				}
			},
			handleSms(val){
				this.form.code = val.slice(-6)
				if(this.smsLock){
					return
				}
				this.smsLock = true
				this.doPoint('ecEnterCode')//埋点
			},
			//获取短信验证码
			getCode(){
				if(!this.form.mobile){
					this.showError = true
					this.showText = '请输入手机号'
					return false
				}
				const regPhone = /^1[3|4|5|6|7|8|9][0-9]{9}$/
				if(!regPhone.test(this.form.mobile)){
					this.showError = true
					this.showText = '请输入正确的手机号'
					return false
				}
				this.showError = false
				this.doPoint('ecGetCode')//埋点
				axios({
					method:"GET",
					url:`${this.$baseURL}/sms`,
					params:{
						phone: this.form.mobile
					}
				}).then(res => {
					if(res.data.code == 0){
						this.countDown()
					}else{
						this.$message({
							message: res.data.msg,
							type: 'warning'
						})
					}
				})
			},
			//短信定时器
			countDown(){
				if(this.count > 0){
					this.timer = true
					setTimeout(() => {
						this.count--
						this.countDown()
					},1000)
				}else{
					this.timer = false
					this.count = 60
				}
			},
			submitForm(formName) {
				this.showError = false
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.doPoint('ecUpPayment')
						this.login()
					} else {
						document.getElementById('form').scrollIntoView({ behavior: 'smooth' })
						return false
					}
				});
			},
			login(){
				axios({
					method:"POST",
					url:`${this.$baseURL}/userLoginSmsVerify`,
					params:{
						userPhone: this.form.mobile,
						code: this.form.code,
						productId: this.productId,
						pathId: this.pathId
					}
				}).then(res => {
					this.$store.commit("SET_PHONE", this.form.mobile)
					this.$store.commit("SET_CODE", this.form.code)
					if(res.data.code == 200){
						let path = `${this.$siteURL}/#/pay/index?productId=${this.productId}&pathId=${this.pathId}&phone=${this.form.mobile}`
						window.location.href = path
					}else if(res.data.code == 1004){
						this.wechatOpen()//已支付时，直接调起获客
						// this.getToken()//已支付时，直接调起小程序
					}else{
						this.$message({message: res.data.message});
					}
				})
			},
			//埋点
			doPoint(val){
				let params = {
					clickId: this.pathId,
					productId: this.productId,
					[val] : 0
				}
				axios({
					method:"POST",
					url:`${this.$baseURL}/insertApplyEc`,
					params: params
				})
			},
			//打开获客链接
			wechatOpen(){
				const phone = this.form.mobile || this.$store.state.userPhone
				axios({
					method:"POST",
					url:`${this.$baseURL}/getWechatIndexClass`,
					params: {
						userPhone: phone
					}
				}).then(res => {
					if(res.data.code == 200){
						let data = res.data.data
						this.custSms(data.class_id,data.class_user_id)
						window.location.href = data.class_wechat_index + '?customer_channel=' + data.class_id + '_H5' + '_' + this.productId
					}else{
						this.$message({message: res.data.message});
					}
				})
			},
			//下发客户短信
			custSms(id,wx){
				axios({
					method:"POST",
					url:`${this.$backend}/customer_acquisition/send_signup_sms`,
					data: {
						"class_id": id,
    					"wx_user_id":wx
					}
				}).then(res => {
					console.log(res)
				})
			},
			// //获取微信toekn
			// getToken(){
			// 	axios.get(`${this.$siteURL}/wxapi/cgi-bin/token?grant_type=client_credential&appid=${this.$wechatAppid}&secret=${this.$wechatSecret}`).then(res => {
			// 		if(res.status == 200){
			// 			this.getScheme(res.data.access_token)
			// 		}
			// 	}).catch(err => {
			// 		console.log(err)
			// 	})
			// },
			// //获取加密scheme码
			// getScheme(token){
			// 	axios({
			// 		method:"POST",
			// 		url:`${this.$siteURL}/wxapi/wxa/generatescheme?access_token=${token}`,
			// 		data:{
			// 			jump_wxa:{
			// 				query:"pathId="+this.pathId  //1.0.3版小程序
			// 			}
			// 		}
			// 	}).then(res => {
			// 		window.location.href = res.data.openlink
			// 	})
			// },
		}
	}
</script>


<style scoped>
	.main{background: #FFD69E;}
	.footer{
		/* background-image: url('./../assets/images/btn2.png'); */
	}
	.price{color: #ff4242;position: fixed;bottom: 20px;font-size: 42px;font-weight: bold;}

	.cbtn{margin: 20px 30px 0px;padding: 18px 25px;background: #BD0700;text-align: center;border-radius: 35px;margin-bottom: 20px;}
	.cbtn .text{animation: testAnimation 1.5s linear infinite;color: #fff;font-size: 1.5rem;letter-spacing: 2px;font-weight: bold;cursor: pointer;}
	/* css3 */
	@keyframes testAnimation {
		0%{
			transform: scale(.9);
		}
		50%{
			transform: scale(1.2);
		}
		100%{
			transform: scale(.9);
		}
	}
	@media screen and (max-width:767px){
		.price{left: 25px;bottom: 5px;}
	}
</style>



// WEBPACK FOOTER //
// src/views/agent/acustLoginPay.vue